import React from 'react';
import { GridColDef, GridRenderCellParams, GridValueGetterParams } from '@mui/x-data-grid';
import { TFunction } from 'react-i18next';

import { Config } from 'src/api/hooks/useConfigs.types';
import { CronJobSwitchCell } from 'src/components/Cron';
import { AccessTokenInfo, OnFbSuccess } from 'src/pages/Configuration/Configuration.types';
import { ConfigValueCell } from 'src/components/Config/ConfigValueCell';

export const ConfigurationHeaders = (
  t: TFunction,
  handleConfigEdit: (editedConfig: Config) => void,
  accessToken: AccessTokenInfo,
  onFbSuccess: (response: OnFbSuccess) => void,
  renewAccessTokenLoading: boolean,
): GridColDef<Config>[] => {
  return [
    {
      headerName: t('configScreen.headers.id'),
      field: 'config.id',
      sortable: false,
      flex: 1,
      valueGetter: (params: GridValueGetterParams<string, Config>) => params.row.id || '-',
      hide: false,
      editable: false,
    },
    {
      headerName: t('configScreen.headers.name'),
      field: 'config.name',
      sortable: false,
      flex: 1,
      valueGetter: (params: GridValueGetterParams<string, Config>) => params.row.name || '-',
      hide: false,
      editable: false,
    },
    {
      headerName: t('configScreen.headers.value'),
      field: 'config.value',
      sortable: false,
      flex: 1,
      renderCell: ({ row }: GridRenderCellParams<string, Config>) => (
        <ConfigValueCell
          row={row}
          expiresAt={accessToken.expiresAt}
          renewedToken={accessToken.token}
          renewAccessTokenLoading={renewAccessTokenLoading}
        />
      ),
    },
    {
      headerName: t('configScreen.headers.cronJobSwitch'),
      field: 'config.cronJobSwitch',
      sortable: false,
      flex: 2,
      renderCell: ({ row }: GridRenderCellParams<boolean, Config>) => (
        <CronJobSwitchCell
          row={row}
          expiresAt={accessToken.expiresAt}
          shouldRenew={accessToken.shouldRenew}
          onConfigEdit={handleConfigEdit}
          onFbSuccess={onFbSuccess}
          renewAccessTokenLoading={renewAccessTokenLoading}
        />
      ),
      hide: false,
      editable: false,
    },
  ];
};
